import { Resource } from 'i18next';
import dadk from 'src/translations/da-dk.json';
import dede from 'src/translations/de-de.json';
import engb from 'src/translations/en-gb.json';
import enus from 'src/translations/en-us.json';
import eses from 'src/translations/es-es.json';
import fifi from 'src/translations/fi-fi.json';
import frfr from 'src/translations/fr-fr.json';
import itit from 'src/translations/it-it.json';
import nbno from 'src/translations/nb-no.json';
import nlnl from 'src/translations/nl-nl.json';
import ptpt from 'src/translations/pt-pt.json';
import svse from 'src/translations/sv-se.json';

const resources: Resource = {
  'da-dk': dadk,
  'de-de': dede,
  'en-gb': engb,
  'en-us': enus,
  'es-es': eses,
  'fi-fi': fifi,
  'fr-fr': frfr,
  'it-it': itit,
  'nb-no': nbno,
  'nl-nl': nlnl,
  'pt-pt': ptpt,
  'sv-se': svse,
};

export default resources;
